import { Container } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useSelector } from 'react-redux'
import { DesktopGeneralInfo } from '../components/detail/DesktopGeneralInfo'
import { MobileGeneralInfo } from '../components/detail/MobileGeneralInfo'
import ParentsManagement from '../components/detail/ParentsManagement'
import { useInitialState } from '../hooks/detail/useInitialState'
import useUserDetailState from '../hooks/detail/useUserDetailState'
import Header from '../../../../shared/components/Header'
import SubHeader from '../../../../shared/styles/Subheader'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { IRootState } from '../../../../../redux/types'
import { UserDetailTabs } from '../components/detail/UserDetailTabs'
import { UserDetailNotifications } from '../components/detail/UserDetailNotifications'
import CardContainer from '../styles/detail/CardContainer'

function UserDetail() {
  const isMobile = useScreenWidth(700)

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  const userId = useInitialState()
  const { clientTypes, handleClickEdit } = useUserDetailState(userId)

  return (
    <>
      <Header title="Perfil" />
      <SubHeader className="profile" />

      {authUser !== null && userProfileSelected !== null && (
        <Container maxWidth="lg">
          <MobileGeneralInfo handleClickEdit={handleClickEdit} />
          <CardContainer>
            <Grid container justifyContent="space-between" alignItems="flex-start" spacing={isMobile ? 2 : 8}>
              <DesktopGeneralInfo clientTypes={clientTypes} handleClickEdit={handleClickEdit} />
              <ParentsManagement />
            </Grid>
            <UserDetailTabs userId={userId} />
          </CardContainer>
          <UserDetailNotifications />
        </Container>
      )}
    </>
  )
}

export default UserDetail
